<template>
  <!-- <div class="biaodi_details"> -->
  <!-- 20250609添加if 上下架 显示 -->
  <div v-if="this.subject.on_sale == 1" class="biaodi_details">
    <!-- 页面头部开始 -->
    <div class="title_box">
      <!-- 标题介绍 -->
      <h1>{{ subject.title }}</h1>
      <!-- 机构信息 -->
      <p><span class="c_gray">{{$t("subject_details.enterprise")}}
        </span>{{ enterprise.title }}</p>
      <p><span class="c_gray">{{$t("subject_details.contact_information")}}
        </span>{{ enterprise.phone }}</p>

      <div class="swiperContainer" v-swiper:mySwiper2="swiperContaine">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in subjects" :key="index" @click="changeDeatil(item.id)">

            <div :class="{red_border:s_id == item.id}" style="margin-right: 17px;">
              <p style="width: 30px; background: #c71622;color:#fff;position:absolute">
                {{item.id}}</p>
              <div class="img_box" :style="{'backgroundImage':'url('+item.img+')'}"></div>
              <p style="background: #c71622;color:#fff;">{{item.biaodiState}}
              </p>
            </div>
            <p class="f12" style="width: 109px;line-height: 16px;">{{item.title}}</p>

          </div>
        </div>
        <!-- <div class="swiper-container"></div> -->
        <div class="swiper-scrollbar"></div>
      </div>

    </div>
    <div class="pj-notice">温馨提示：网络拍卖存在一定时间延迟，为避免错过合理的出价时间，请您尽早出价，以避免出价失败！</div>
    <!-- 页面头部结束 -->
    <!-- 页面中间开始-->
    <div class="pp_details">
      <!-- 中间左部开始 -->
      <div class="l_box" id="l_box">
        <!-- 图片展示开始 -->
        <div class="imgs_box">
          <!-- PC端开始 -->
          <BiaodiSwiper :recordsList="recordsList" v-if="recordsList"></BiaodiSwiper>
          <div style="padding:0 20px 20px 20px;">
            <p style="display:inline;float:left">
              <img src="@/assets/images/see2.png" style="width:20px;margin-bottom:-5px;">
              {{Number(subject.view_count) + Number(subject.view_base_count)}}{{$t("subject_details.onlookers")}}
            </p>
            <p style="display:inline;float:right;cursor:pointer">
              <span @click="collect" v-show="!downIcon">
                <img src="@/assets/images/love.png" style="width:15px;margin-bottom:-2px;">
                收藏
              </span>
              <span @click="collect" v-show="downIcon">
                <img src="@/assets/images/loves.png" style="width:15px;margin-bottom:-2px;">
                已收藏
              </span>
            </p>
          </div>
        </div>
        <!-- 图片展示结束 -->
        <!-- 核心业务开始 -->
        <div class="price_box">
          <h3>
            {{$t("subject_details.number")}}【{{ subject.id }}】{{ subject.title }}
          </h3>
          <div class="my-bg">
            <!-- 价格展示 -->
            <div class="cur_price">
              <p class="lt f12 c_gray" style="display:inline">
                {{$t("subject_details.current_price")}}
                <span class="f30 c_red">{{ (subject.price) }}</span>
                <span class="c_red">元</span>
                <span class="new_unit" v-if="subject.new_unit"> / {{subject.new_unit}}</span>
              </p>
              <div class="rt" v-if="sign.no">
                <!-- <p>{{$t("subject_details.leading_number")}}{{auctions[0] ? auctions[0].no: '暂无数据'}}</p> -->
                <p>
                  {{$t("subject_details.your_number")}}{{sign.no ? sign.no: '无'}}
                </p>
              </div>
            </div>
            <!-- 倒计时器 -->
            <div v-if="!Astop">
              <p class="f16" style="float:left;margin-top:10px;">
                {{timerleft}}：
              </p>
              <p v-show="showEnded==0" class="f16" style="float:left;margin-left:10px;">
                <span class="f30 c_red">{{countdown.day}}</span>{{$t("subject_details.day")}}
                <span class="f30 c_red">{{countdown.hour}}</span>{{$t("subject_details.hour")}}
                <span class="f30 c_red">{{countdown.min}}</span>{{$t("subject_details.min")}}
                <span class="f30 c_red">{{countdown.sec}}</span>{{$t("subject_details.s")}}
                <!-- <span class="f50 c_red">{{countdown.ms}}</span> -->
              </p>
              <p v-show="showEnded==1" class="f30" style="float:left;margin-left:10px;color:#999">{{BDendtime}}</p>
            </div>
          </div>
          <!-- 出价开始 -->
          <div style="text-align:center">
            <div class="my-endshow" :class="{c_red:is_sold==1}" v-show="showEnded==1">
              {{endMessage}}
            </div>
            <div class="change_price" v-show="showChangePrice">
              <!-- 减价按钮 -->
              <!-- <div class="jian f30" v-on:click="tapMarkdown">
                <img src="@/assets/images/cheapen.png" alt="">
              </div> -->
              <!-- 加价幅度 -->
              <button class="price_view" @click="markupTime = 1" :class="{red:markupTime == 1}">
                <!-- +{{subject.add_price * 1}}元 -->
                +{{ (Number(subject.add_price) * 1).toFixed(2) }}元
              </button>
              <button class="price_view" @click="markupTime = 2" :class="{red:markupTime == 2}">
                <!-- +{{subject.add_price * 2}}元 -->
                +{{ (Number(subject.add_price) * 2).toFixed(2) }}元
              </button>
              <button class="price_view" @click="markupTime = 3" :class="{red:markupTime == 3}">
                <!-- +{{subject.add_price * 3}}元 -->
                +{{ (Number(subject.add_price) * 3).toFixed(2) }}元
              </button>
              <button class="price_view" @click="markupTime = 5" :class="{red:markupTime == 5}">
                <!-- +{{subject.add_price * 5}}元 -->
                +{{ (Number(subject.add_price) * 5).toFixed(2) }}元
              </button>
              <!-- 加价按钮 -->
              <!-- <div class="jia f30" v-on:click="tapMarkup">
                <img src="@/assets/images/raise.png" alt="">
              </div> -->
            </div>
            <!-- <p class="c_gray" style="margin: 10px;" v-show="showChangePrice">
              注：（每份金额{{ Math.trunc(subject.add_price) }}元）
            </p> -->
            <!-- 按钮 -->
            <router-link :to="{ path:'/login'}" v-if="loginButton">
              <button class="cp_btn">
                登录/注册
              </button>
            </router-link>
            <button v-else class="cp_btn" v-on:click="tapOffer" v-show="showButton" :disabled="disabled" :class="{confirm_btn:disabled}">
              {{ button }}
            </button>
            <p class="enroll_stop f16" v-show="showMessage" v-html="message" style="text-align:left"></p>
          </div>
          <!-- 出价结束 -->
          <!-- 拍卖规则开始 -->
          <div class="other f12">
            <a class="ff_pri"><span class="icon"></span>成交后支付佣金，按照成交价{{subject.yj_fee}}%的比例收取。&nbsp;<a href="/serivce" class="color-blue">查看更多></a></a>
            <a class="ff_pri2"><span class="icon"></span>成交后需另支付{{subject.fw_fee}}%的软件服务费（<a href="/vip" class="color-blue">拍界VIP会员</a>免费）&nbsp;<a href="/serivce3" class="color-blue">查看更多></a></a>
            <ul class="c_gray">
              <!-- 第一列 -->
              <li>
                <el-popover placement="top-start" trigger="hover" width="100" :content="this.convertCurrency((subject.start_price))">
                  <span slot="reference">
                    {{$t("subject_details.starting_price")}}<em class="my-em">{{(subject.start_price) }} 元<span v-if="subject.new_unit">/{{subject.new_unit}}</span></em>
                  </span>
                </el-popover>
                <br>
                <el-popover placement="top-start" trigger="hover" width="100" :content="subject.valuation_price>0 ? this.convertCurrency((subject.valuation_price)): this.$t('subject_details.no_data')">
                  <span slot="reference">
                    {{$t("subject_details.evaluation_price")}}<em class="my-em">{{subject.valuation_price > 0?(subject.valuation_price)+"元": '无'}}</em>
                  </span>
                </el-popover>
                <p>{{$t("subject_details.free_bidding_time")}}<em class="my-em">{{sfreeTime}}</em></p>
              </li>
              <!-- 第二列 -->
              <li>
                <el-popover placement="top-start" trigger="hover" width="100" :content="this.convertCurrency((subject.deposit))">
                  <span slot="reference">
                    {{$t("subject_details.deposit")}}<em class="my-em">{{ Math.trunc(subject.deposit) }} 元</em>
                  </span>
                </el-popover>
                <br>
                <el-popover placement="top-start" trigger="hover" width="100" content="拍卖企业设定的标的最低成交价格，最终的价格低于该价格即流拍">
                  <span slot="reference">
                    {{$t("subject_details.reserve_price")}}
                  </span>
                  <span slot="reference">
                    <em class="my-em">{{reserve_price > 0? '有' : ''}}</em>
                  </span>
                  <span slot="reference" style="color: red">
                    {{reserve_price > 0? '' : '无'}}
                  </span>
                </el-popover>
                <br>
                <el-popover placement="top-start" trigger="hover" width="100" content="竞拍最后1分内，若有用户出价，即进入限时竞价时间。">
                  <span slot="reference">{{$t("subject_details.time_limited_bidding_time")}}<em class="my-em">1{{$t("subject_details.min")}}</em></span>
                </el-popover>
              </li>
              <!-- 第三列 -->
              <li>
                <el-popover placement="top-start" trigger="hover" width="100" :content="this.convertCurrency(Number(subject.add_price))">
                  <span slot="reference">
                    {{$t("subject_details.markup_range")}}
                    <em class="my-em">
                      {{ Number(subject.add_price).toFixed(2) }} 元
                    </em>
                  </span>
                </el-popover>
                <br>
                <el-popover placement="top-start" trigger="hover" width="100" content="优先购买权又称先买权，是指法律赋予特定对象（特定人） 依照法律规定或合同约定，在出卖标的于第三人时，享有的在同等条件下优先">
                  <span slot="reference">{{$t("subject_details.preemptive_right_holder")}}<em class="my-em">{{$t("subject_details.no")}}</em></span>
                </el-popover>
                <br>
                <el-popover v-if="subject.new_nums!=0 && subject.new_nums!=null">
                  <span slot="reference">总量：<em class="my-em">{{subject.new_nums}}{{subject.new_unit}}</em></span>
                </el-popover>
              </li>
            </ul>
            <p class="c_gray" style="line-height:25px;">{{$t("subject_details.opening_time")}}<em class="my-em">{{subject.start_at}}</em></p>
            <p class="c_gray">
              {{$t("subject_details.please_pay_deposit_after_registration")}}
              <router-link :to="{ path:'/problem', query:{ curLi: 0, curUl: 1, isMobile: false }}" class="pmr_pc" style="color: #444444;">
                {{$t("subject_details.how_to_pay_the_deposit")}}
              </router-link>
              <router-link :to="{ path:'/problem#pm_rule', query:{ isMobile: true }}" class="pmr_mobile" style="color: #444444;">
                {{$t("subject_details.how_to_pay_the_deposit")}}
              </router-link>
            </p>
            <hr>
            <!-- <p class="c_gray" v-if="subject.bank_id == 5">吉林省崇晟科贸有限公司开户行:<br>{{$global.banks[subject.id%5].account_bank}}<br>{{$global.banks[subject.id%5].account_number}}</p>
            <p class="c_gray" v-else>吉林省崇晟科贸有限公司开户行:<br>{{$global.banks[subject.bank_id].account_bank}}<br>{{$global.banks[subject.bank_id].account_number}}</p> -->
            <!-- <p class="c_gray" v-if="this.sign.bank" style="color:red;">拍界（吉林省）拍卖有限公司开户行:<br>{{this.sign.bank}}<br>{{this.sign.i_acct_no}}</p> -->
            <!-- 20240707保证金到账后不显示 -->
            <p class="c_gray" v-if="this.sign.is_receive==0" style="color:red;">拍界（吉林省）拍卖有限公司开户行:<br>{{this.sign.bank}}<br>{{this.sign.i_acct_no}}
            </p>
            <!-- <hr> -->
            <!-- <div class="c_gray money_send_tel ">
              <p>{{$t("subject_details.payment_location_of_online_margin")}}</p>
              <p><img src="@/assets/images/money_send.png" alt="" class="money_send_img"></p>
              <p><img src="@/assets/images/money_send2.png" alt="" class="money_send_img2"></p>
              <hr>
            </div> -->
            <p class="c_gray" style="color:red;">{{$t("subject_details.bidding_rules")}}</p>

            <p style="color: #444444;">
              <span class="c_gray">{{$t("subject_details.final_payment_method")}}</span>{{$t("subject_details.offline_transaction")}}
            </p>
            <!-- 20250419 根据需求更改 -->
            <p style="color: #444444;" v-if="subject.balance_end_text">
              <span class="c_gray">{{$t("subject_details.deadline_for_final_payment")}}</span>{{ subject.balance_end_text }}
            </p>
            <p style="color: #444444;" v-else>
              <span class="c_gray">{{$t("subject_details.deadline_for_final_payment")}}</span>{{$t("subject_details.within_3_working_days_after_the_transaction")}}
            </p>

          </div>
          <!-- 拍卖规则结束 -->
        </div>
        <!-- 核心业务结束 -->
      </div>
      <!-- 中间左部结束 -->
      <!-- 中间右部开始 -->
      <div class="r_box">
        <!-- 拍卖师TAB开始 -->
        <ul class="pms_nav">
          <li @click="r_tab = 0" :class="{current:r_tab == 0}">{{$t("subject_details.auctioneers_speech")}}</li>
          <li @click="r_tab = 1" :class="{current:r_tab == 1}">{{$t("subject_details.auctioneer_information")}}</li>
        </ul>
        <div class="pms_detail" ref="pmmsgScroll">
          <!-- 拍卖师发言 -->
          <div class="fayan" v-show="r_tab == 0">
            <p class="paijie">
              标的信息由【拍界官方】提供,如发现标的存在问题请与官方客服联系，投诉电话：400-9005-905
            </p>
            <div class="paijie_message" v-for="(subjectMessage,index) in subjectMessages" :key="index">
              <p class="paijie_timer">
                <span>拍界官方</span> | {{subjectMessage.created_at}}
              </p>
              <p class="paijie_messages">{{subjectMessage.content}}</p>
            </div>
          </div>
          <!-- 拍卖师信息 -->
          <div class="xinxi" v-show="r_tab == 1">
            <!-- <img src="../assets/images/pms.png">
            <p>姓名:高彦</p>
            <p>拍卖师证号：1900223</p> -->
            <img src="../assets/images/pms8.jpg">
            <p>姓名:汤文清</p>
            <p>拍卖师证号：31220250800003700056</p>
            <img src="../assets/images/pms9.jpg">
            <p>姓名:乔威</p>
            <p>拍卖师证号：2100182</p>
            <img src="../assets/images/pms1.jpg">
            <p>姓名:万泰福</p>
            <p>拍卖师证号：3500269</p>
            <img src="../assets/images/pms2.jpg">
            <p>姓名:刘巍</p>
            <p>拍卖师证号：2800160</p>
            <img src="../assets/images/pms3.jpg">
            <p>姓名:张雪珍</p>
            <p>拍卖师证号：1800686</p>
            <!-- <img src="../assets/images/pms4.jpg">
            <p>姓名:曹家麟</p>
            <p>拍卖师证号：31220220800003300190</p> -->
            <!-- <img src="../assets/images/pms5.jpg">
            <p>姓名:葛增誉</p>
            <p>拍卖师证号：2100175</p> -->
            <!-- <img src="../assets/images/pms6.jpg">
            <p>姓名:王芳</p>
            <p>拍卖师证号：1900803</p> -->
            <img src="../assets/images/pms7.png">
            <p>姓名:陈皋</p>
            <p>拍卖师证号：31220221100003400218</p>
          </div>
        </div>
        <!-- 拍卖师TAB结束 -->

        <!-- 竞价记录开始 -->
        <ul class="state">
          <li>
            <p>{{$t("subject_details.state")}}</p>
            <p>{{$t("subject_details.bidding_number")}}</p>
            <p>{{$t("subject_details.offer")}}</p>
          </li>
          <li v-for="(item,index) in auctions.slice(0,8)" :key="index">
            <p>{{ item.is_lead==1 ? '领先' : '淘汰' }}</p>
            <p>{{ item.no }}</p>
            <p>{{ (item.price) }}</p>
          </li>
        </ul>
        <!-- 竞价记录结束 -->
      </div>
      <!-- 中间右部结束 -->
    </div>
    <div class="IInput" v-if="customer.is_pm == 1">
      <input type="text" name="content" placeholder="( 编辑 )" v-model="content" list="a">
      <button class="btn" @click="MessAge">发 送</button>
      <div style="width:900px;">
        <datalist id="a">
          <option>【拍界官方】提供,如发现标的存在问题请与官方客服联系，投诉电话：400-9005-905</option>
          <option>【拍界官方】欢迎各位竞买人参加电缆厂整厂设备专场拍卖会，我们的拍卖会将在10时30分准时开始。</option>
          <option>【拍界官方】请各位竞买人选择网络信号较强的区域参加竞拍，同时在竞拍的过程中，注意页面刷新。</option>
          <option>【拍界官方】剩余30分钟进入自由竞价时间。</option>
          <option>【拍界官方】马上进入竞拍倒计时，请各位竞买人再次检查网络信号。</option>
          <option>【拍界官方】马上进入限时竞价倒计时，请各位竞买人再次检查网络信号。</option>
          <option>【拍界官方】各位竞买人注意，请尽量不要在最后2秒加价，可能会因为网络延迟，造成不必要的损失。</option>
          <option>【拍界官方】本次拍卖，加价幅度是5000元。竞买人可按自己的实际情况进行调整。</option>
          <option>【拍界官方】现已进入自由竞价时间，自由竞价时间为15分钟。</option>
          <option>【拍界官方】现已进入限时竞价时间，限时竞价时间为1分钟。</option>
          <option>【拍界官方】马上进入限时竞价时间，限时竞价时间为1分钟。</option>
          <option>【拍界官方】还剩五分钟进入限时竞价时间，限时竞价时间为1分钟，请检查自己的网络信号。</option>
          <option>【拍界官方】在拍卖过程中有任何问题可以随时与我们取得联系，024-31976760、15710557521</option>
          <option>【拍界官方】请各位竞买人一定详细阅读我公司上传至本场拍卖会中的《竞拍须知》、《重要提示》等相关拍卖文件。</option>
          <option>【拍界官方】最后预祝各位竞买人竞投成功。</option>
        </datalist>
      </div>

    </div>
    <!-- 页面中间结束-->
    <JpPress></JpPress>
    <!-- 页面尾部开始 -->
    <div class="pm_notice">
      <ul class="t_nav">
        <li @click="tab = 0" :class="{active:tab == 0}">{{$t("subject_details.introduction_of_subject_matter")}}</li>
        <li @click="tab = 1" :class="{active:tab == 1}">{{$t("subject_details.notice")}}</li>
        <li @click="tab = 2" :class="{active:tab == 2}">{{$t("subject_details.bidding_notice")}}</li>
        <li @click="tab = 3" :class="{active:tab == 3}">{{$t("subject_details.bidding_record")}}<!--({{auctions.length}})-->
        </li>
      </ul>
      <ul class="t_view">
        <!-- 标的介绍 -->
        <li v-show="tab == 0">
          <h2>{{$t("subject_details.introduction_of_subject_matter")}}</h2>
          <div class="showimg" v-html="subject.summary">
          </div>
          <br>
          <div v-if="subject.com=='联通'">
            <div v-if="subject.files">
              <button @click="downloadFile" style="color:red;" title="点击下载">下载：《竞买人廉洁自律承诺书》模版</button>&nbsp;&nbsp;&nbsp;
            </div>

            <div v-if="subject.files1">
              <button @click="downloadFile1" style="color:red;" title="点击下载">下载：《现场勘察确认书》模版</button>&nbsp;&nbsp;&nbsp;
            </div>
            <div v-if="subject.files2">
              <button @click="downloadFile2" style="color:red;" title="点击下载">下载：《竞价确认函》模版</button>&nbsp;&nbsp;&nbsp;
            </div>
            <div v-if="subject.files3 ">
              <button @click="downloadFile3" style="color:red;" title="点击下载">下载：《出口管制承诺函》模版</button>&nbsp;&nbsp;&nbsp;
            </div>
            <div v-if="subject.files4 ">
              <button @click="downloadFile4" style="color:red;" title="点击下载">下载：标的清单</button>&nbsp;&nbsp;&nbsp;
            </div>
            <div v-if="subject.files7 ">
              <button @click="downloadFile7" style="color:red;" title="点击下载">下载：合同模版</button>&nbsp;&nbsp;&nbsp;
            </div>
            <div v-if="subject.files8 ">
              <button @click="downloadFile8" style="color:red;" title="点击下载">下载：履约、预付款保函</button>&nbsp;&nbsp;&nbsp;
            </div>
          </div>

          <div v-if="subject.com=='移动'">
            <div v-if="subject.files">
              <button @click="downloadFile" style="color:red;" title="点击下载">下载：拍卖规则模版</button>&nbsp;&nbsp;&nbsp;
            </div>

            <div v-if="subject.files1">
              <button @click="downloadFile1" style="color:red;" title="点击下载">下载：竞买人信息登记表模版</button>&nbsp;&nbsp;&nbsp;
            </div>
            <div v-if="subject.files2">
              <button @click="downloadFile2" style="color:red;" title="点击下载">下载：授权委托书模版</button>&nbsp;&nbsp;&nbsp;
            </div>
            <div v-if="subject.files3 ">
              <button @click="downloadFile3" style="color:red;" title="点击下载">下载：承诺书模版</button>&nbsp;&nbsp;&nbsp;
            </div>
            <div v-if="subject.files4 ">
              <button @click="downloadFile4" style="color:red;" title="点击下载">下载：踏勘确认书</button>&nbsp;&nbsp;&nbsp;
            </div>
            <div v-if="subject.files5">
              <button @click="downloadFile5" style="color:red;" title="点击下载">下载：标的清单</button>&nbsp;&nbsp;&nbsp;
            </div>
            <!-- <div v-if="subject.files8 ">
              <button @click="downloadFile8" style="color:red;" title="点击下载">下载：履约、预付款保函</button>&nbsp;&nbsp;&nbsp;
            </div> -->
          </div>

          <div v-if="subject.com=='普通'">
            <div v-if="subject.files1">
              <button @click="downloadFile1" style="color:red;" title="点击下载">下载：勘察确认书模版</button>&nbsp;&nbsp;&nbsp;
            </div>
            <div v-if="subject.files4 ">
              <button @click="downloadFile4" style="color:red;" title="点击下载">下载：标的清单</button>&nbsp;&nbsp;&nbsp;
            </div>
            <div v-if="subject.files5">
              <button @click="downloadFile5" style="color:red;" title="点击下载">下载：合同模版 </button>&nbsp;&nbsp;&nbsp;
            </div>
          </div>
          <!-- <div v-if="subject.files5 ">
            <button @click="downloadFile5">6.《危险废物经营许可证》核实截图页面</button>&nbsp;&nbsp;&nbsp;
          </div>
          <div v-if="subject.files6 ">
            <button @click="downloadFile6">7.下载附件文件7</button>&nbsp;&nbsp;&nbsp;
          </div> -->

          <br>
          <br>
          <div class="showimg" v-for="(item,index) in subjectImgs" :key="index" style="position: relative; ">
            <img :src="item.url" alt="" />
            <p class="watermark"><img style="width:auto" src="@/assets/images/waterMark.png"></p>
          </div>
        </li>
        <!-- 拍卖公告 -->
        <li v-show="tab == 1">
          <h2>{{$t("subject_details.notice")}}</h2>
          <div class="showimg" v-html="subject.notice"></div>
        </li>
        <!-- 竞拍须知 -->

        <!-- <li v-show="tab == 2">
          <h2>{{$t("subject_details.bidding_notice")}}</h2>
          <div class="showimg" v-html="subject.content1"></div>
        </li> -->

        <div v-if="subject.com=='普通'">
          <li v-show="tab == 2">
            <BiaodiIntroduce :serviceFeeText="getServiceFeeText()"></BiaodiIntroduce>
          </li>
        </div>
        <div v-if="subject.com=='联通' || subject.com=='移动'">
          <li v-show="tab == 2">
            <h2>{{$t("subject_details.bidding_notice")}}</h2>
            <div class="showimg" v-html="subject.content1"></div>
          </li>
        </div>
        <!-- <div v-if="subject.com=='联通'">
          <li v-show="tab == 2">
            <BiaodiNotice></BiaodiNotice>
          </li>
        </div> -->
        <!-- 竞价记录 -->
        <li v-show="tab == 3">
          <h2>{{$t("subject_details.bidding_record")}}</h2>
          <div class="table_ul fw f16">
            <div class="table_li">{{$t("subject_details.state")}}</div>
            <div class="table_li">{{$t("subject_details.bidding_number")}}</div>
            <div class="table_li">{{$t("subject_details.price")}}</div>
            <div class="table_li">{{$t("subject_details.time")}}</div>
          </div>
          <div class="scroll_box">
            <div class="table_ul" v-for="(item,index) in auctions" :key="index">
              <div class="table_li">{{ item.is_lead==1 ? '领先' : '淘汰' }}</div>
              <div class="table_li">{{ item.no }}</div>
              <div class="table_li">{{ (item.price) }}</div>
              <div class="table_li">{{ item.created_at }}</div>
            </div>

            <!-- <div v-if="subject.com == '联通'">
              <h2 @click="downloadReport">{{this.subject.title}}终结报告Download</h2>
            </div> -->

          </div>
        </li>

      </ul>
    </div>
    <!-- 页面尾部结束 -->
    <!-- 页面弹窗开始 -->
    <!-- loading图 -->
    <div class="loading_box" v-show="showLoading">
      <div class="loading">
        <img src="@/assets/images/Loading.png" alt="">
        <p>竞拍结算中...</p>
      </div>
    </div>
    <!-- 恭喜竞拍成功 -->
    <div class="happy_box" v-show="happy">happy_box
      <div class="happy">
        <img src="@/assets/images/happy.png" alt="" class="bghappy">
        <img src="@/assets/images/close.png" alt="" class="close" @click="close" style="z-index: 10000000">
        <img src="@/assets/images/bigflower.png" alt="" class="bigflower">
        <img src="@/assets/images/bigflower.png" alt="" class="bigflower2">
        <img src="@/assets/images/bigflower.png" alt="" class="bigflower3">
        <img src="@/assets/images/bigflower.png" alt="" class="bigflower4">
      </div>

    </div>
    <!-- 页面弹窗结束 -->
    <!-- 报名前填写银行卡信息 -->
    <el-dialog title="银行卡信息" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="开户银行全称（含支行）">
          <el-input v-model="form.account_bank" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="银行卡号">
          <el-input v-model="form.account_number" autocomplete="off"></el-input>
        </el-form-item>

        <!-- 联通标的：附件上传 -->
        <el-form-item v-if="subject.com == '联通'" class="compact-upload">
          <!-- 联通注册说明 -->

          <!-- 中国联通注册提示 -->
          <div class="liantong-register-tip">
            <div class="register-icon">
              <i class="el-icon-document-checked"></i>
            </div>

            <div class="register-content">
              <div class="register-title">
                中国联通合作方注册证明
              </div>

              <div class="register-desc">
                请先前往中国联通合作方平台注册，完成后上传相关证明材料。
              </div>

              <a href="https://www.cuecp.cn" target="_blank" rel="noopener noreferrer" class="register-link">
                <i class="el-icon-link"></i>
                https://www.cuecp.cn
                <i class="el-icon-top-right"></i>
              </a>
            </div>
          </div>

          <!-- 保留原来的示例图片 -->
          <div>
            例图：
            <img src="@/assets/images/example.png" style="width: 500px; max-width: 100%;">
          </div>

          <!-- 联通附件列表 -->
          <div v-for="(label, index) in labels" :key="index" class="upload-row">
            <span class="upload-label">
              {{ label }}：
            </span>

            <!-- 选择并上传文件 -->
            <el-upload :auto-upload="false" :show-file-list="false" :on-change="(file) => handleTempFile(file, index)" action="#">
              <el-button size="mini" type="primary">
                选择文件
              </el-button>
            </el-upload>

            <!-- 上传状态 -->
            <span v-if="uploadStatus[index]" class="status-icon">
              <i :class="uploadStatus[index].icon" :style="{ color: uploadStatus[index].color }"></i>
              {{ uploadStatus[index].text }}
            </span>

            <!-- 上传成功后的图片预览 -->
            <div v-if="form[`images${index === 0 ? '' : index}`]" class="compact-preview">
              <el-image :src="form[`images${index === 0 ? '' : index}`]" fit="cover"></el-image>
            </div>
          </div>

        </el-form-item>

        <el-form-item v-if="subject.com=='移动'" class="compact-upload">
          <div v-for="(label, index) in labels_yidong" :key="index" class="upload-row">
            <span class="upload-label">{{ label }}：</span>

            <!-- 修改后的上传组件 -->
            <el-upload :auto-upload="false" :show-file-list="false" :on-change="(file) => handleTempFile(file, index)" action="#">
              <el-button size="mini" type="primary">选择文件</el-button>
            </el-upload>

            <!-- 状态指示器 -->
            <span v-if="uploadStatus[index]" class="status-icon">
              <i :class="uploadStatus[index].icon" :style="{color: uploadStatus[index].color}"></i>
              {{ uploadStatus[index].text }}
            </span>

            <!-- 精简版预览 -->
            <div v-if="form[`images${index === 0 ? '' : index}`]" class="compact-preview">
              <el-image :src="form[`images${index === 0 ? '' : index}`]" fit="cover"></el-image>
            </div>
          </div>
        </el-form-item>

        <!-- 普通标的：上传标的踏勘确认书 -->
        <el-form-item v-if="subject.com == '普通'" class="compact-upload">

          <div class="upload-row">

            <span class="upload-label">标的踏勘确认书：</span>

            <el-upload :auto-upload="false" :show-file-list="false" :on-change="(file) => handleTempFile(file, 12)" action="#">
              <el-button size="mini" type="primary">
                选择文件
              </el-button>
            </el-upload>

            <!-- 上传状态 -->
            <span v-if="uploadStatus[12]" class="status-icon">
              <i :class="uploadStatus[12].icon" :style="{ color: uploadStatus[12].color }"></i>
              {{ uploadStatus[12].text }}
            </span>

            <!-- 文件上传后的预览 -->
            <div v-if="form.images12" class="compact-preview">
              <el-image :src="form.images12" fit="cover"></el-image>
            </div>

          </div>

        </el-form-item>

      </el-form>

      <div style="text-align: left;">
        拍卖结束后，我们将在5个工作日内为您返还保证金。为确保您的保证金能够原路返回，请您认真填写银行卡号及开户行信息，如有问题请您联系客服。<br />电话：0431-80872580
      </div>
      <div class="c_red" style="text-align: left;margin-top: 20px;" v-show="is_Waring">*{{ submitWaring }}</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button :disabled="bmDis" type="primary" @click="submitBankForm">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 报名前填写银行卡信息结束 -->
  </div>

  <div v-else class="biaodi_details">
    <div class="title_box">
      <!-- 标题介绍 -->
      <h1>{{ subject.title }}</h1>
      <!-- 机构信息 -->
      <p><span class="c_gray">{{$t("subject_details.enterprise")}}
        </span>{{ enterprise.title }}</p>
      <p><span class="c_gray">{{$t("subject_details.contact_information")}}
        </span>{{ enterprise.phone }}</p>

      <div class="swiperContainer" v-swiper:mySwiper2="swiperContaine">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in subjects" :key="index" @click="changeDeatil(item.id)">

            <div :class="{red_border:s_id == item.id}" style="margin-right: 17px;">
              <p style="width: 30px; background: #c71622;color:#fff;position:absolute">
                {{item.id}}</p>
              <div class="img_box" :style="{'backgroundImage':'url('+item.img+')'}"></div>
              <p style="background: #c71622;color:#fff;">{{item.biaodiState}}
              </p>
            </div>
            <p class="f12" style="width: 109px;line-height: 16px;">{{item.title}}</p>

          </div>
        </div>
        <!-- <div class="swiper-container"></div> -->
        <div class="swiper-scrollbar"></div>
      </div>

    </div>
    <div class="pj-notice">温馨提示：网络拍卖存在一定时间延迟，为避免错过合理的出价时间，请您尽早出价，以避免出价失败！</div>
    <!-- <div class="pp_details">该标的已下架!</div> -->
    <!-- 页面中间结束-->
    <JpPress></JpPress>
  </div>
</template>

<script>
import { decryptAES } from '@/utils/crypto';
const wx = require('weixin-js-sdk');
import qs from 'qs';
import BiaodiIntroduce from '@/components/BiaodiIntroduce.vue';
import BiaodiNotice from '@/components/BiaodiNotice.vue';
// import PicZoom from 'vue-piczoom';
import BiaodiSwiper from '@/components/BiaodiSwiper.vue';
import JpPress from '@/components/JpPress.vue';

export default {
  metaInfo () {
    return {
      title: this.subject.title + '_拍界',
      meta: [{
        name: "keywords",
        content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
      }, {
        name: "description",
        content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
      }]
    }
  },
  data () {
    return {
      content: '',
      swiperContaine: {
        // pagination: {
        // 	el: '.swiper-container',
        // },
        // direction: 'vertical', // 垂直切换选项
        // loop: true, // 循环模式选项
        slidesPerView: 6, //滚动速度
        // navigation: {
        //     nextEl: '.swiper-button-next',
        //     prevEl: '.swiper-button-prev',
        //     },	
        scrollbar: {
          el: '.swiper-scrollbar',
        },
      },
      r_tab: 0,
      tab: 0,
      markupTime: 1,
      s_id: this.$route.query.id,
      meeting_id: 0,
      subject: {
        price: 0,
        title: '拍界',
        start_at: '',
        end_at: '',
        reserve_price: '',
        bank_id: 5
      },
      enterprise: {},
      sign: {
        status: null
      },
      customer: {},
      auctions: [],
      subjects: [],
      subjectImgs: [],
      subjectMessages: [],
      timer: '',
      nowTime: '',
      timerleft: '距离开始时间',
      button: '点击报名',
      showMessage: true,
      showChangePrice: false,
      showButton: true,
      disabled: false,
      happy: false,
      showLoading: false,
      token: null,
      // 倒计时数据
      countdown: {
        day: '00',
        hour: '00',
        min: '00',
        sec: '00',
        ms: '0'
      },
      dialogFormVisible: false,
      form: {
        account_number: '',
        account_bank: '',
        images: '',
        images1: '',
        images2: '',
        images3: '',
        images4: '',
        images5: '',
        images6: '',
        images7: '',
        images8: '',
        images9: '',
        images10: '',
        images11: '',
        images12: '',

      },
      is_Waring: false,
      submitWaring: '',
      BDendtime: '',
      showEnded: 0,
      endMessage: '',
      is_sold: 0,
      recordsList: '',
      downIcon: false,
      wximg: '',
      Astop: false,
      is_pause: 0,
      loginButton: 0,
      bmDis: false,
      labels: [
        '中国联通合作方注册证明',
        '营业执照副本',
        '法人身份证',
        '《授权委托书》',
        '被授权人身份证',
        '《再生资源回收经营者备案登记证明》',
        '《廉洁自律承诺书》',
        '《现场勘察确认书》',
        '《竞价确认函》',
        '《出口管制承诺函》',
        '《危险废物经营许可证》',
        '《危险废物经营许可证》核实截图页面',
      ],
      labels_yidong: [
        '拍卖规则',
        '竞买人信息登记表',
        '授权委托书',
        '承诺书',
        '踏勘确认书',
        '营业执照',
        '危险废物经营许可证及查询链接',
        '废弃电器电子产品处理资格证书及查询链接',
        '法人身份证及开户行信息',
        '竟价保证金缴纳凭证',
        '报废机动车回收拆解资质',

      ],
      uploadStatus: {} // 用于存储各文件的上传状态

    }
  },
  created () {
    // 显示公共栏
    this.$emit('header', true);
    this.$emit('footer', true);
    this.setToken();
    // 加载路由参数
    this.getRouteQuery()
    // 获取标的
    this.getSubject();
    // 检查时间
    this.checkTime();

    // 获取标的图片
    this.getEnterprise();
    this.collectGet();
    // this.getSubjects();
    // 页面至顶部
    window.scrollTo(0, 0);
    // 微信分享
    this.wxShare();


  },

  // sockets:{
  // 	//这里是监听connect事件
  // 	connect: function() {
  // 		// 获取每台客服端生成的id
  // 		this.websocketid = this.$socket.id;
  // 		console.log('链接服务器');
  // 	},
  // 	sendMsg: function(val){
  // 		console.log(val)
  // 	}
  // },
  methods: {
    // 根据标的 id 返回不同的服务费描述
    getServiceFeeText () {
      // 这里填你需要特殊处理的标的 id
      if (this.subject.id == 6536) {        // ← 改成你那个特殊标的 id
        return '平台服务费按拍卖成交价1%收取。';
      }

      // 其他普通标的保持默认
      return '平台服务费按拍卖成交价5%以下收取。';
    },
    handleTempFile (file, index) {
      // 更新上传状态
      this.$set(this.uploadStatus, index, {
        icon: 'el-icon-loading',
        color: '#409EFF',
        text: '上传中...'
      });

      // 保持与后台完全一致的FormData结构
      const formData = new FormData();
      formData.append('apiToken', this.token); // 保持参数名一致
      formData.append('meeting_id', this.meeting_id || 'null'); // 保持null传递

      // 关键修改：使用file.raw保持文件对象原始结构
      formData.append('file', file.raw);

      // 保持原有的Content-Type设置
      const config = {
        headers: {
          'Content-Type': `multipart/form-data; boundary=${new Date().getTime()}`
        }
      };

      this.axios.post(this.$global.apiUrl.upload_file, formData, config)
        .then(response => {
          // 严格按后台返回结构处理
          const result = response.data;
          if (result.url) {
            const field = `images${index === 0 ? '' : index}`;
            this.$set(this.form, field, result.url);

            this.$set(this.uploadStatus, index, {
              icon: 'el-icon-check',
              color: '#67C23A',
              text: '上传完成'
            });
            console.log("更新后的 form:", this.form);
          } else {
            throw new Error(result.message || '上传失败');
          }
        })
        .catch(error => {
          this.$set(this.uploadStatus, index, {
            icon: 'el-icon-close',
            color: '#F56C6C',
            text: error.message
          });
          console.error('文件传递失败:', error);
        });
    },
    getFiles (event, index) {
      const file = event.target.files[0]; // 获取选中的文件
      console.log("当前文件:", file);
      console.log("当前索引:", index);
      if (!file) return;  // 如果没有文件，直接返回

      let formData = new FormData();
      formData.append('apiToken', this.token);  // 添加 API Token
      formData.append('meeting_id', this.meeting_id); // 添加其他需要传递的参数
      formData.append('file', file);  // 添加文件

      // 打印上传的 FormData
      console.log("上传的数据:", formData);

      // 发起文件上传请求
      this.axios.post(this.$global.apiUrl.upload_file, formData, {
        headers: {
          'Content-Type': 'multipart/form-data;boundary=' + new Date().getTime()
        }
      })
        .then((response) => {
          // 假设返回的 URL 是 response.data.url
          const imageUrl = response.data.url;
          console.log("图片 URL:", imageUrl);

          if (index === 0) {
            this.$set(this.form, 'images', imageUrl);  // 更新 images
          } else {
            this.$set(this.form, `images${index}`, imageUrl);  // 更新 images1, images2, ...
          }

          console.log("更新后的 form:", this.form);
        })
        .catch((error) => {
          console.error("文件上传失败:", error);
        });
    },
    // 上传图片
    getFile: function (event) {

      const file = event.target.files[0]
      //请求接口前需要传的参数
      let formData = new FormData()
      formData.append('apiToken', this.token)
      formData.append('file', file)
      this.axios.post(this.$global.apiUrl.upload_file, formData, {
        headers: {
          'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime()
        }
      })
        .then((response) => {
          this.form.images = response.data.url
        })
        .catch(() => { })
    },
    getFile1: function (event) {

      const file1 = event.target.files[0]
      // console.log(file);
      //请求接口前需要传的参数
      let formData = new FormData()
      formData.append('apiToken', this.token)
      formData.append('file', file1)
      this.axios.post(this.$global.apiUrl.upload_file, formData, {
        headers: {
          'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime()
        }
      })
        .then((response) => {
          this.form.images1 = response.data.url
        })
        .catch(() => { })
    },
    getFile2: function (event) {

      const file2 = event.target.files[0]
      // console.log(file);
      //请求接口前需要传的参数
      let formData = new FormData()
      formData.append('apiToken', this.token)
      formData.append('file', file2)
      this.axios.post(this.$global.apiUrl.upload_file, formData, {
        headers: {
          'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime()
        }
      })
        .then((response) => {
          this.form.images2 = response.data.url
        })
        .catch(() => { })
    },
    getFile3: function (event) {

      const file3 = event.target.files[0]
      // console.log(file);
      //请求接口前需要传的参数
      let formData = new FormData()
      formData.append('apiToken', this.token)
      formData.append('file', file3)
      this.axios.post(this.$global.apiUrl.upload_file, formData, {
        headers: {
          'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime()
        }
      })
        .then((response) => {
          this.form.images3 = response.data.url
        })
        .catch(() => { })
    },
    getFile4: function (event) {

      const file4 = event.target.files[0]
      // console.log(file);
      //请求接口前需要传的参数
      let formData = new FormData()
      formData.append('apiToken', this.token)
      formData.append('file', file4)
      this.axios.post(this.$global.apiUrl.upload_file, formData, {
        headers: {
          'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime()
        }
      })
        .then((response) => {
          this.form.images4 = response.data.url
        })
        .catch(() => { })
    },
    getFile5: function (event) {

      const file5 = event.target.files[0]
      // console.log(file);
      //请求接口前需要传的参数
      let formData = new FormData()
      formData.append('apiToken', this.token)
      formData.append('file', file5)
      this.axios.post(this.$global.apiUrl.upload_file, formData, {
        headers: {
          'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime()
        }
      })
        .then((response) => {
          this.form.images5 = response.data.url
        })
        .catch(() => { })
    },
    getFile6: function (event) {

      const file6 = event.target.files[0]
      // console.log(file);
      //请求接口前需要传的参数
      let formData = new FormData()
      formData.append('apiToken', this.token)
      formData.append('file', file6)
      this.axios.post(this.$global.apiUrl.upload_file, formData, {
        headers: {
          'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime()
        }
      })
        .then((response) => {
          this.form.images6 = response.data.url
        })
        .catch(() => { })
    },
    getFile7: function (event) {

      const file7 = event.target.files[0]
      // console.log(file);
      //请求接口前需要传的参数
      let formData = new FormData()
      formData.append('apiToken', this.token)
      formData.append('file', file7)
      this.axios.post(this.$global.apiUrl.upload_file, formData, {
        headers: {
          'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime()
        }
      })
        .then((response) => {
          this.form.images7 = response.data.url
        })
        .catch(() => { })
    },
    getFile8: function (event) {

      const file8 = event.target.files[0]
      // console.log(file);
      //请求接口前需要传的参数
      let formData = new FormData()
      formData.append('apiToken', this.token)
      formData.append('file', file8)
      this.axios.post(this.$global.apiUrl.upload_file, formData, {
        headers: {
          'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime()
        }
      })
        .then((response) => {
          this.form.images8 = response.data.url
        })
        .catch(() => { })
    },
    getFile9: function (event) {

      const file9 = event.target.files[0]
      // console.log(file);
      //请求接口前需要传的参数
      let formData = new FormData()
      formData.append('apiToken', this.token)
      formData.append('file', file9)
      this.axios.post(this.$global.apiUrl.upload_file, formData, {
        headers: {
          'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime()
        }
      })
        .then((response) => {
          this.form.images9 = response.data.url
        })
        .catch(() => { })
    },
    getFile10: function (event) {

      const file10 = event.target.files[0]
      // console.log(file);
      //请求接口前需要传的参数
      let formData = new FormData()
      formData.append('apiToken', this.token)
      formData.append('file', file10)
      this.axios.post(this.$global.apiUrl.upload_file, formData, {
        headers: {
          'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime()
        }
      })
        .then((response) => {
          this.form.images10 = response.data.url
        })
        .catch(() => { })
    },
    getFile11: function (event) {

      const file11 = event.target.files[0]
      // console.log(file);
      //请求接口前需要传的参数
      let formData = new FormData()
      formData.append('apiToken', this.token)
      formData.append('file', file11)
      this.axios.post(this.$global.apiUrl.upload_file, formData, {
        headers: {
          'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime()
        }
      })
        .then((response) => {
          this.form.images11 = response.data.url
        })
        .catch(() => { })
    },
    downloadFile: function () {

      if (this.subject.files) {
        var fileUrl = "https://admin.paijie.com/" + this.subject.files;

        const link = document.createElement('a');
        link.href = fileUrl;
        link.target = '_blank';
        link.download = "附件文件";
        // document.body.appendChild(link);

        link.setAttribute('download', fileUrl);
        link.click();

      } else {
        this.$alert('无附件文件', '提示', {
          confirmButtonText: '确定'
        });
        return;
      }

    },
    downloadFile1: function () {
      // console.log(this.subject.files1);
      if (this.subject.files1) {
        var fileUrl = "https://admin.paijie.com/" + this.subject.files1;

        const link = document.createElement('a');
        link.href = fileUrl;
        link.target = '_blank';
        link.download = "附件文件";
        // document.body.appendChild(link);

        link.setAttribute('download', fileUrl);
        link.click();

      } else {
        this.$alert('无附件文件', '提示', {
          confirmButtonText: '确定'
        });
        return;
      }

    },
    downloadFile2: function () {

      if (this.subject.files2) {
        var fileUrl = "https://admin.paijie.com/" + this.subject.files2;

        const link = document.createElement('a');
        link.href = fileUrl;
        link.target = '_blank';
        link.download = "附件文件";
        // document.body.appendChild(link);

        link.setAttribute('download', fileUrl);
        link.click();

      } else {
        this.$alert('无附件文件', '提示', {
          confirmButtonText: '确定'
        });
        return;
      }

    },
    downloadFile3: function () {

      if (this.subject.files3) {
        var fileUrl = "https://admin.paijie.com/" + this.subject.files3;

        const link = document.createElement('a');
        link.href = fileUrl;
        link.target = '_blank';
        link.download = "附件文件";
        // document.body.appendChild(link);

        link.setAttribute('download', fileUrl);
        link.click();

      } else {
        this.$alert('无附件文件', '提示', {
          confirmButtonText: '确定'
        });
        return;
      }

    },
    downloadFile4: function () {

      if (this.subject.files4) {
        var fileUrl = "https://admin.paijie.com/" + this.subject.files4;

        const link = document.createElement('a');
        link.href = fileUrl;
        link.target = '_blank';
        link.download = "附件文件";
        // document.body.appendChild(link);

        link.setAttribute('download', fileUrl);
        link.click();

      } else {
        this.$alert('无附件文件', '提示', {
          confirmButtonText: '确定'
        });
        return;
      }

    },
    downloadFile5: function () {

      if (this.subject.files5) {
        var fileUrl = "https://admin.paijie.com/" + this.subject.files5;

        const link = document.createElement('a');
        link.href = fileUrl;
        link.target = '_blank';
        link.download = "附件文件";
        // document.body.appendChild(link);

        link.setAttribute('download', fileUrl);
        link.click();

      } else {
        this.$alert('无附件文件', '提示', {
          confirmButtonText: '确定'
        });
        return;
      }

    },
    downloadFile7: function () {

      if (this.subject.files7) {
        var fileUrl = "https://admin.paijie.com/" + this.subject.files7;

        const link = document.createElement('a');
        link.href = fileUrl;
        link.target = '_blank';
        link.download = "附件文件";
        // document.body.appendChild(link);

        link.setAttribute('download', fileUrl);
        link.click();

      } else {
        this.$alert('无附件文件', '提示', {
          confirmButtonText: '确定'
        });
        return;
      }

    },
    downloadFile8: function () {

      if (this.subject.files8) {
        var fileUrl = "https://admin.paijie.com/" + this.subject.files8;

        const link = document.createElement('a');
        link.href = fileUrl;
        link.target = '_blank';
        link.download = "附件文件";
        // document.body.appendChild(link);

        link.setAttribute('download', fileUrl);
        link.click();

      } else {
        this.$alert('无附件文件', '提示', {
          confirmButtonText: '确定'
        });
        return;
      }

    },

    // downloadFile5:function(){

    //   if(this.subject.files5){
    //     var fileUrl = "https://admin.paijie.com/"+this.subject.files5;

    //     const link = document.createElement('a');
    //     link.href=fileUrl;
    //     link.target='_blank';
    //     link.download="附件文件";
    //     // document.body.appendChild(link);

    //     link.setAttribute('download', fileUrl);
    //     link.click();

    //   }else{
    //     this.$alert('无附件文件', '提示', {
    //       confirmButtonText: '确定'
    //     });
    //     return;
    //   }

    // },
    // downloadFile6:function(){

    //   if(this.subject.files6){
    //     var fileUrl = "https://admin.paijie.com/"+this.subject.files6;

    //     const link = document.createElement('a');
    //     link.href=fileUrl;
    //     link.target='_blank';
    //     link.download="附件文件";
    //     // document.body.appendChild(link);

    //     link.setAttribute('download', fileUrl);
    //     link.click();

    //   }else{
    //     this.$alert('无附件文件', '提示', {
    //       confirmButtonText: '确定'
    //     });
    //     return;
    //   }

    // },
    downloadReport: function () {
      this.axios.get("https://local.paijie.com/api/DownLoad/Report", {
        params: {
          id: this.s_id
        }
      })
        .then((response) => {

          // 这是请求了另一个接口状态所以不一样
          if (response.data.code == 0) {
            const link = document.createElement('a');
            link.href = response.data.data;
            link.target = '_blank';
            link.download = "附件文件";
            // document.body.appendChild(link);

            link.setAttribute('download', response.data.data);
            link.click();
          } else {
            this.$alert(response.data.msg, '提示', {
              confirmButtonText: '确定'
            });

          }
        });
    },
    // changeDeatil: function (id) {
    //   this.s_id = id;
    //   this.getSubject();
    //   this.collectGet();
    // },
    changeDeatil: function (id) {
      // 设置当前选中的 ID
      this.s_id = id;

      // 跳转到新的路由，同时携带查询参数
      this.$router.push({
        path: '/biaodiDetails',
        query: {
          id: id,
          meeting_id: this.meeting_id
        }
      }).then(() => {
        // 因为加载数据有些问题，只能重新刷新页面
        window.location.reload();
      }).catch(error => {

        console.error(error);
      });
    },


    MessAge: function () {
      if (this.content == "") {
        this.$alert('内容不能为空', '提示', {
          confirmButtonText: '确定'
        });
        return;
      }
      let strings = qs.stringify({
        content: this.content,
        subjectId: this.s_id,
        apiToken: this.token
      })
      this.axios.post(this.$global.apiUrl.subject_messages_set, strings, {})

        .then((response) => {

          if (response.data.error.code == 0) {
            this.subjectMessages = response.data.subjectMessages;
            this.content = '';
          }
          else {

            // console.log(response.data.error.message)
            this.$alert(response.data.error.message, '提示', {
              confirmButtonText: '确定'
            });
          }
        })

    },

    // 获取路由参数
    getRouteQuery: function () {


      if (this.$route.query.meeting_id !== undefined) {
        this.meeting_id = this.$route.query.meeting_id;
      }

    },
    setToken () {
      if (localStorage.getItem('apiToken') != null) {
        let token = localStorage.getItem('apiToken');
        if (token != null) {
          this.token = token;
          // 获取用户信息
          this.getCustomer()
        }
      }
    },
    getSubjects () {

      if (this.meeting_id != 0) {
        this.axios.get(this.$global.apiUrl.subjects, {
          params: {
            meeting_id: this.meeting_id,
            order: "end_at DESC",
            limit: 10
          }
        })
          .then((response) => {
            if (response.data.error.code == 0) {
              this.subjects = this.computedStatus(response.data.subjects);
            }
          });
      }

    },
    // 计算标的状态
    computedStatus: function (subjects) {
      // console.log(0.1+0.2)
      let _this = this;
      subjects.forEach(function (value, index, array) {
        // console.log(subjects);
        // console.log(value);
        // console.log(index);
        // console.log(array);
        // 距离开始的时间
        var startTime = parseInt((new Date(value.start_at.replace(/\-/g, '/')).getTime() - new Date().getTime()));
        // 距离结束的时间
        var endTime = parseInt((new Date(value.end_at.replace(/\-/g, '/')).getTime() - new Date().getTime()));

        if (startTime > 0) {
          array[index]['biaodiState'] = _this.$t("subject.list.state.s_1")
        }
        if (startTime <= 0 & endTime > 0) {
          array[index]['biaodiState'] = _this.$t("subject.list.state.s_2")
        }
        if (startTime < 0 & endTime <= 0) {
          array[index]['biaodiState'] = _this.$t("subject.list.state.s_3")

        }

      });
      return subjects;
    },
    // 获取标的
    getSubject () {
      this.axios.get(this.$global.apiUrl.subjects_show, {
        params: {
          id: this.s_id,
          apiToken: this.token
        }
      })
        .then((response) => {
          if (response.data.error.code == 0) {
            this.nowTime = new Date(response.headers.date).getTime();



            this.subject = response.data.subject;

            // console.log('========== 标的详情排查 ==========');
            // console.log('请求的标的ID：', this.s_id);
            // console.log('接口返回的标的ID：', this.subject.id);
            // console.log('标的名称：', this.subject.title);
            // console.log('上下架状态：', this.subject.on_sale);
            // console.log('图片数据：', this.subject.images);
            // console.log('完整商品数据：', this.subject);
            // console.log('=================================');

            this.auctions = response.data.auctions;
            this.subjectMessages = response.data.subjectMessages;
            let rawSubject = response.data.subject;
            if (rawSubject.notice) {
              rawSubject.notice = decryptAES(rawSubject.notice);
            }
            if (rawSubject.content1) {
              rawSubject.content1 = decryptAES(rawSubject.content1);
            }
            if (rawSubject.summary) {
              rawSubject.summary = decryptAES(rawSubject.summary);
            }
            if (this.markupTime == 0) {
              if (response.data.subject.sold_count > 0) {
                this.markupTime = 1;
              }
            }
            this.is_pause = this.subject.is_pause;

            // 获取标的图片
            this.getSubjectImgs();

            if (this.meeting_id != 0) {
              this.getSubjects();
            }
            else if (this.subject.meeting_id != 0) {
              this.meeting_id = this.subject.meeting_id;
              this.getSubjects();
            } else {
              this.subjects = this.computedStatus([response.data.subject]);
            }
          } else if (response.data.error.code == 200) {
            this.$alert(
              response.data.error.message || '该标的不存在',
              '温馨提示',
              {
                confirmButtonText: '确定',
                type: 'warning',
                center: true,
                showClose: false,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                callback: () => {
                  this.$router.back();
                }
              }
            );
            return;

          } else {

            // 其他接口错误
            this.$message.error(response.data.error.message || '请求失败');

          }
        });
    },

    // 获取标的图片
    getSubjectImgs () {
      this.subjectImgs = JSON.parse(this.subject.images);
      this.recordsList = [];
      this.wximg = this.subjectImgs[0].url;
      this.subjectImgs.forEach((item, index) => {
        if (index < 5) {
          this.recordsList[index] = {
            "id": index + 1,
            "iconImageUrl": item.url,
            "coverImageUrl": item.url,
            "backImageUrl": item.url,
          }
        }
      });
    },

    getEnterprise () {
      this.axios.get(this.$global.apiUrl.subjects_imgs, {
        params: {
          id: this.s_id
        }
      })
        .then((response) => {
          if (response.data.error.code == 0) {
            this.enterprise = response.data.enterprise;
            // this.subjectImgs  = response.data.subjectImgs;
          }
        });
    },

    // 检查时间
    checkTime () {
      if (this.endBalanceTime < 0) {
        // 竞拍结束
        this.closeAuction()
      } else {
        // 开始计时
        this.countDown();
      }
    },
    // 微信分享
    wxShare () {
      const url = window.location.href.split('#')[0] //向服务端提供授权url参数，并且不需要#后面的部分
      this.axios.get(this.$global.apiUrl.wxuser_signature, {
        params: {
          url: url
        }
      })
        .then((response) => {
          if (response.data.error.code == 0) {
            wx.config({
              debug: false, // 开启调试模式,
              appId: response.data.signPackage.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
              timestamp: response.data.signPackage.timestamp, // 必填，生成签名的时间戳
              nonceStr: response.data.signPackage.nonceStr, // 必填，生成签名的随机串
              signature: response.data.signPackage.signature, // 必填，签名，见附录1
              jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
          }
        })
    },
    //礼花关闭
    close () {
      this.happy = false
    },
    // 结束竞拍
    closeAuction () {
      this.timerleft = "竞拍结束";
      this.showButton = false;
      this.showMessage = false;
      this.showEnded = 1;
      this.BDendtime = this.subject.end_at;
      this.postSubjectMessage('end');
      // this.endMessage = '本拍品已流拍';
      // console.log(this.getSign());
      // 20220526
      // 这里是定义报名后，产品未参与竞拍的用户(后期可以改逻辑，将这下面的添加进去，因为没有对应的id) 
      // ['391'=>'K3201236','621'=>'A8790885']
      if (this.subject.id == '391') {
        this.endMessage = '恭喜 ' + 'K3201236' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '621') {
        this.endMessage = '恭喜 ' + 'A8790885' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '606') {
        this.endMessage = '恭喜 ' + 'O9235479' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '736') {
        this.endMessage = '恭喜 ' + 'I6170594' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '737') {
        this.endMessage = '恭喜 ' + 'A2267293' + ' 竞拍成功';
        this.is_sold = 1;
      }

      if (this.subject.id == '735') {
        this.endMessage = '恭喜 ' + 'U9346623' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '780') {
        this.endMessage = '恭喜 ' + 'F4561517' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '751') {
        this.endMessage = '恭喜 ' + 'Y5468539' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '762') {
        this.endMessage = '恭喜 ' + 'C2215117' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '763') {
        this.endMessage = '恭喜 ' + 'J1897535' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '764') {
        this.endMessage = '恭喜 ' + 'B5441527' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '765') {
        this.endMessage = '恭喜 ' + 'J4714317' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '766') {
        this.endMessage = '恭喜 ' + 'Q7418658' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '767') {
        this.endMessage = '恭喜 ' + 'C5194151' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '768') {
        this.endMessage = '恭喜 ' + 'J9867817' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '769') {
        this.endMessage = '恭喜 ' + 'I1299503' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '770') {
        this.endMessage = '恭喜 ' + 'C7560285' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '749') {
        this.endMessage = '恭喜 ' + 'J7011232' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '650') {
        this.endMessage = '恭喜 ' + 'P3337500' + ' 竞拍成功';
        this.is_sold = 1;
      }


      if (this.subject.id == '785') {
        this.endMessage = '恭喜 ' + 'Q3284923' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '888') {
        this.endMessage = '恭喜 ' + 'W5186547' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '924') {
        this.endMessage = '恭喜 ' + 'W5186547' + ' 竞拍成功';
        this.is_sold = 1;
      }

      if (this.subject.id == '952') {
        this.endMessage = '恭喜 ' + 'B4864653' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '962') {
        this.endMessage = '恭喜 ' + 'Z1657359' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '1043') {
        this.endMessage = '恭喜 ' + 'P5092543' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '1577') {
        this.endMessage = '恭喜 ' + 'G1041755' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '2921') {
        this.endMessage = '恭喜 ' + 'V1805879' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '2919') {
        this.endMessage = '恭喜 ' + 'Z2288229' + ' 竞拍成功';
        this.is_sold = 1;
      }

      if (this.subject.id == '2926') {
        this.endMessage = '恭喜 ' + 'T3323473' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '2957') {
        this.endMessage = '恭喜 ' + 'D2333482' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '2970') {
        this.endMessage = '恭喜 ' + 'B1599792' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '2978') {
        this.endMessage = '恭喜 ' + 'S3508219' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '2975') {
        this.endMessage = '恭喜 ' + 'S3074223' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '2977') {
        this.endMessage = '恭喜 ' + 'B8944615' + ' 竞拍成功';
        this.is_sold = 1;
      }
      if (this.subject.id == '2976') {
        this.endMessage = '恭喜 ' + 'Y1193588' + ' 竞拍成功';
        this.is_sold = 1;
      }

      if (this.subject.is_sold == 1) {
        this.endMessage = '恭喜 ' + this.auctions[0].no + ' 竞拍成功';
        this.is_sold = 1;
      }


      if (this.subject.id == '630') {
        this.endMessage = '本拍品已流拍';

      }
      if (this.subject.id == '2524') {
        this.endMessage = '本拍品已流拍';

      }
      if (this.subject.id == '757') {
        this.endMessage = '本拍品已流拍';

      }
      if (this.subject.id == '2515') {
        this.endMessage = '本拍品已流拍';

      }
      // 20220526  // } else {
      //   // 3天内显示
      //   if (Date.parse(this.BDendtime)+3*24*3600*1000 > new Date()) {
      //     this.endMessage = '竞价审核中';
      //   }
      // }
      if (this.auctions[0] !== null && this.auctions[0].no == this.sign.no) {
        if (this.subject.is_sold == 1) {
          this.happy = true;
        }
      }
    },
    //收藏
    collect () {

      this.axios.get(this.$global.apiUrl.collect_store, {
        params: {
          apiToken: this.token,
          subject_id: this.s_id
        }
      })
        .then((response) => {
          if (response.data.error.code == 0) {
            this.downIcon = !this.downIcon;
          } else {
            this.alertError(response.data.error);
          }
        });
    },
    //收藏
    collectGet () {

      this.axios.get(this.$global.apiUrl.collect_get, {
        params: {
          apiToken: this.token,
          subject_id: this.s_id
        }
      })
        .then((response) => {
          if (response.data.error.code == 0) {
            this.downIcon = response.data.out.is_fav == 1 ? true : false;
          } else {
            // this.alertError(response.data.error);
          }
        });
    },

    // 加价
    tapMarkup: function () {
      this.markupTime = this.markupTime + 1;
    },



    // 减价
    tapMarkdown: function () {
      var minMarkupTime = 1;
      if (this.subject.sold_count == 0) {
        minMarkupTime = 0;
      }
      if (this.markupTime > minMarkupTime) {
        this.markupTime = this.markupTime - 1;
      } else {
        this.$alert('不能再减啦', '提示', {
          confirmButtonText: '确定'
        });
      }
    },
    // 获取用户信息
    getCustomer: function () {
      // 请求数据
      this.axios.get(this.$global.apiUrl.customer, {
        params: {
          apiToken: this.token
        }
      })
        .then((response) => {
          if (response.data.error.code == 0) {
            this.customer = response.data.customer;
            // 获取报名信息
            this.getSign()
          } else {
            this.alertError(response.data.error);
          }
        });
    },

    // 获取报名信息
    getSign: function () {
      // 请求数据
      this.axios.get(this.$global.apiUrl.sign, {
        params: {
          apiToken: this.token,
          subjectId: this.s_id
        }
      })
        .then((response) => {
          if (response.data.error.code == 0) {
            if (response.data.sign) {
              this.sign = response.data.sign;
            }
          } else {
            this.alertError(response.data.error);
          }
        });
    },

    // 创建报名
    postSign: function () {
      this.bmDis = true;
      if (this.form.account_bank == '' || this.form.account_bank.length == 0) {
        this.is_Waring = true;
        this.submitWaring = '请输入开户银行全称（含支行）！';
        this.bmDis = false;
        return false;
      } else if (this.form.account_number == '' || this.form.account_number.length == 0) {
        this.is_Waring = true;
        this.submitWaring = '请输入银行卡号！';
        this.bmDis = false;

        return false;
      }
      // else if(this.form.images == ''){
      //   this.is_Waring = true;
      //   this.submitWaring = '请上传注册证明！';
      //   this.bmDis = false;
      // }
      else {
        this.is_Waring = false;
        let signDatas = qs.stringify({
          subjectId: this.s_id,
          apiToken: this.token,
          account_number: this.form.account_number,
          account_bank: this.form.account_bank,
          images: this.form.images,
          images1: this.form.images1,
          images2: this.form.images2,
          images3: this.form.images3,
          images4: this.form.images4,
          images5: this.form.images5,
          images6: this.form.images6,
          images7: this.form.images7,
          images8: this.form.images8,
          images9: this.form.images9,
          images10: this.form.images10,
          images11: this.form.images11,
          images12: this.form.images12,
        })
        this.axios.post(this.$global.apiUrl.sign_store, signDatas, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
          .then((response) => {
            if (response.data.error.code == 0) {
              this.sign = response.data.sign;
              this.dialogFormVisible = false;
              this.bmDis = false;
            } else {
              this.alertError(response.data.error);
            }
          })
      }
    },

    // 创建标的消息
    postSubjectMessage: function (type) {
      let subjectMessageDatas = qs.stringify({
        subjectId: this.s_id,
        type: type,
      })
      this.axios.post(this.$global.apiUrl.subject_messages_store, subjectMessageDatas, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .then((response) => {
          if (response.data.error.code == 0) {
            this.subjectMessages = response.data.subjectMessages;
          } else {
            this.alertError(response.data.error);
          }
        })
    },

    // 创建拍卖纪录
    postAuction: function () {

      let auctionDatas = qs.stringify({
        subjectId: this.s_id,
        apiToken: this.token,
        // price: this.subject.add_price * this.markupTime + this.subject.price * 1,
        price: (
          Math.round(
            (
              Number(this.subject.price) +
              Number(this.subject.add_price) * Number(this.markupTime)
            ) * 100
          ) / 100
        ).toFixed(2),
        markupTime: this.markupTime,
      })
      this.axios.post(this.$global.apiUrl.subject_auctions_store, auctionDatas, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .then((response) => {
          if (response.data.error.code == 0) {
            this.subject = response.data.subject;
            this.auctions = response.data.auctions;
            this.nowTime = new Date(response.headers.date).getTime();
            this.markupTime = 1;
            clearInterval(this.timer);
            this.countDown();

          } else {
            this.alertError(response.data.error);
          }
        })
    },
    // 出价
    tapOffer: function () {
      // this.$socket.emit('sendMsg', "msg")
      // 判断是否过期
      if (this.endBalanceTime < 0) {
        this.$alert('竞拍已结束', '提示', {
          confirmButtonText: '确定'
        });
        return;
      }

      this.checkToken();
      this.checkRealStatus();

      if (this.customer.enterprise_status == 1) {
        if (this.button == '点击报名') {
          // 提示报名
          this.alertSign();
        }
        if (this.button == '点击出价') {

          this.checkSignStatus();


          // 联通项目已报名并且保证金已缴费，才能出价 2024
          if (this.sign.com == '联通') {
            if (this.sign.status == 1 && this.sign.is_receive == 1) {
              // this.alertAuction();
              this.postAuction();
            }
          } else {
            // 已报名，直接出价
            if (this.sign.status == 1) {
              // this.alertAuction();
              this.postAuction();
            }
          }

        }
      }
    },
    checkToken () {
      // 判断登录状态
      if (this.token == null) {
        // 未登录，重定向至登录页
        this.alertToLogin('请登录后进行操作');
      }
    },
    checkSignStatus () {
      // 未报名
      if (this.sign.status == null) {
        // console.log(this.sign.status);
        this.alertSign();
      }

      // 审核中
      if (this.sign.status == 2) {
        this.$alert('报名审核中…请完成线下保证金支付', '提示', {
          confirmButtonText: '确定'
        });
      }
      if (this.sign.com == '联通') {
        if (this.sign.is_receive == 0) {
          this.$alert('报名审核中…请完成线下保证金支付', '提示', {
            confirmButtonText: '确定'
          });
        }
      }

      if (this.sign.status == 0) {
        this.$alert('对不起，您没有竞拍资格', '提示', {
          confirmButtonText: '确定'
        });
      }
    },
    checkRealStatus () {
      if (this.customer.enterprise_status == 3) {
        // 提示实名
        this.$alert('请完成实名认证', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.$router.push({
              path: '/person',
              query: { id: 1 }
            })
          }
        });
      }

      if (this.customer.enterprise_status == 2) {
        // 提示实名
        this.$alert('实名认证审核中，请耐心等待', '提示', {
          confirmButtonText: '确定'
        });
      }

      if (this.customer.enterprise_status == 0) {
        // 提示实名
        this.$alert('实名认证失败，请重新提交审核', '提示', {
          confirmButtonText: '确定'
        });
      }
    },
    alertError (error) {
      if (error.code == 401) {
        // 清除过期token
        window.localStorage.clear();
        this.alertToLogin('登录已过期,请重新登录！');
      } else {
        this.$alert(error.message, '提示', {
          confirmButtonText: '确定'
        });
      }
    },
    alertToLogin (msg) {
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.$router.push({
          path: '/login',
        })
      });
    },
    alertSign () {
      console.log(this.subject.notice_e)
      console.log(Date.now())
      // 联通标的  增加拍卖截止时间限制
      if (this.subject.com == '联通') {

        if (this.subject.notice_e != false) {
          if (this.subject.notice_e > Date.now()) {
            // console.log(1);
            this.$confirm("<div style='text-align:center;'>您确定报名?</div><div style='text-align:center;color:red;font-weight:800;'>当无竞买人出价时，第一个缴纳保证金者（以到账时间为准）为最终买受人。请仔细阅读拍卖公告、竞价须知与竞价规则，谨慎报名！</div>", '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              dangerouslyUseHTMLString: true,
            }).then(() => {
              this.alertBank();
            });
          } else {
            // console.log(1.5);
            this.$alert('对不起,已经超过了报名时间', '提示', {
              confirmButtonText: '确定'
            });
          }
        } else {
          // console.log(2);
          this.$confirm("<div style='text-align:center;'>您确定报名?</div><div style='text-align:center;color:red;font-weight:800;'>当无竞买人出价时，第一个缴纳保证金者（以到账时间为准）为最终买受人。请仔细阅读拍卖公告、竞价须知与竞价规则，谨慎报名！</div>", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
          }).then(() => {
            this.alertBank();
          });
        }
      } else {
        // console.log(3);
        if (this.subject.notice_e != false) {
          if (this.subject.notice_e > Date.now()) {
            // console.log(1);
            this.$confirm("<div style='text-align:center;'>您确定报名?</div><div style='text-align:center;color:red;font-weight:800;'>当无竞买人出价时，第一个缴纳保证金者（以到账时间为准）为最终买受人。请仔细阅读拍卖公告、竞价须知与竞价规则，谨慎报名！</div>", '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              dangerouslyUseHTMLString: true,
            }).then(() => {
              this.alertBank();
            });
          } else {
            // console.log(1.5);
            this.$alert('对不起,已经超过了报名时间', '提示', {
              confirmButtonText: '确定'
            });
          }
        } else {
          // console.log(2);
          this.$confirm("<div style='text-align:center;'>您确定报名?</div><div style='text-align:center;color:red;font-weight:800;'>当无竞买人出价时，第一个缴纳保证金者（以到账时间为准）为最终买受人。请仔细阅读拍卖公告、竞价须知与竞价规则，谨慎报名！</div>", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
          }).then(() => {
            this.alertBank();
          });
        }
      }

    },
    alertBank () {
      this.dialogFormVisible = true;
    },
    submitBankForm () {
      this.postSign();
    },
    alertAuction () {
      this.$confirm('您确定出价?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.postAuction();
      }).catch(() => { });
    },
    setCountdown (leftTime) {
      let d = parseInt(leftTime / 1000 / 3600 / 24);
      let h = parseInt(leftTime / 1000 / 3600 % 24);
      let m = parseInt(leftTime / 1000 / 60 % 60);
      let s = parseInt(leftTime / 1000 % 60);

      // let ms = parseInt(leftTime % 1000/10);
      // 			ms < 10 ? ms = "0" + ms : ms;



      d < 10 ? d = "0" + d : d;
      h < 10 ? h = "0" + h : h;
      m < 10 ? m = "0" + m : m;
      s < 10 ? s = "0" + s : s;


      this.countdown = {
        day: d,
        hour: h,
        min: m,
        sec: s,
        // ms:ms
      };
    },
    // 计时器
    countDown: function () {
      this.timer = setInterval(() => {
        if (this.is_pause == 1) {
          this.button = '暂停中';
          this.Astop = true;
          this.disabled = true;
          clearInterval(this.timer);
          return;
        }

        if (this.token == null) {
          this.loginButton = 1;
        }

        if (this.startBalanceTime > 0) {
          this.setCountdown(this.startBalanceTime);
          this.nowTime += 1000;
        }

        if (this.startBalanceTime > 0 && this.startBalanceTime < 7200000) {
          // this.button="报名结束";
          // this.disabled = true;

          // this.nowTime += 1000;
        }
        // console.log(this.countdown.ms)

        if (this.startBalanceTime <= 0 && this.endBalanceTime >= 0) {
          this.timerleft = "距离出价结束时间";
          this.button = "点击出价";
          this.showChangePrice = true;
          this.showMessage = false;
          this.disabled = false;
          this.showLoading = false;
          this.setCountdown(this.endBalanceTime);

          // if ( parseInt(this.endBalanceTime % 1000/100) == 0) {
          this.getSubject();
          // }
        }

        if (this.endBalanceTime < 0) {
          this.showLoading = true;
          this.disabled = true
          // if (this.countdown.ms == 0) {
          this.getSubject();
          // }
        }

        if (this.endBalanceTime < -5000) {
          this.showLoading = false;
          this.showChangePrice = false;
          clearInterval(this.timer);
          this.loginButton = 0;
          // 竞拍结束
          this.closeAuction();
          return;
        }
      }, 1000)
    },
    pmmsgScroll: function () {
      this.$nextTick(function () {
        this.$refs.pmmsgScroll.scrollTo({
          top: 1000000000000,
          behavior: 'smooth'
        });
      });
    },
    // 人民币小写转大写
    convertCurrency: function (money) {
      //汉字的数字
      var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
      //基本单位
      var cnIntRadice = new Array('', '拾', '佰', '仟');
      //对应整数部分扩展单位
      var cnIntUnits = new Array('', '万', '亿', '兆');
      //对应小数部分单位
      var cnDecUnits = new Array('角', '分', '毫', '厘');
      //整数金额时后面跟的字符
      var cnInteger = '整';
      //整型完以后的单位
      var cnIntLast = '元';
      //最大处理的数字
      var maxNum = 999999999999999.9999;
      //金额整数部分
      var integerNum;
      //金额小数部分
      var decimalNum;
      //输出的中文金额字符串
      var chineseStr = '';
      //分离金额后用的数组，预定义
      var parts;
      if (money == '') {
        return '';
      }
      money = parseFloat(money);
      if (money >= maxNum) {
        //超出最大处理数字
        return '';
      }
      if (money == 0) {
        chineseStr = cnNums[0] + cnIntLast + cnInteger;
        return chineseStr;
      }
      //转换为字符串
      money = money.toString();
      if (money.indexOf('.') == -1) {
        integerNum = money;
        decimalNum = '';
      } else {
        parts = money.split('.');
        integerNum = parts[0];
        decimalNum = parts[1].substr(0, 4);
      }
      //获取整型部分转换
      if (parseInt(integerNum, 10) > 0) {
        var zeroCount = 0;
        var IntLen = integerNum.length;
        for (var i = 0; i < IntLen; i++) {
          var n = integerNum.substr(i, 1);
          var p = IntLen - i - 1;
          var q = p / 4;
          var m = p % 4;
          if (n == '0') {
            zeroCount++;
          } else {
            if (zeroCount > 0) {
              chineseStr += cnNums[0];
            }
            //归零
            zeroCount = 0;
            chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
          }
          if (m == 0 && zeroCount < 4) {
            chineseStr += cnIntUnits[q];
          }
        }
        chineseStr += cnIntLast;
      }
      //小数部分
      if (decimalNum != '') {
        var decLen = decimalNum.length;
        for (let i = 0; i < decLen; i++) {
          let n = decimalNum.substr(i, 1);
          if (n != '0') {
            chineseStr += cnNums[Number(n)] + cnDecUnits[i];
          }
        }
      }
      if (chineseStr == '') {
        chineseStr += cnNums[0] + cnIntLast + cnInteger;
      } else if (decimalNum == '') {
        chineseStr += cnInteger;
      }
      return chineseStr;
    },
    initWeChatShare () {
      const _this = this;
      wx.ready(() => {
        wx.updateAppMessageShareData({
          title: '拍界',
          desc: _this.subject.title,
          link: window.location.href,
          imgUrl: _this.wximg,
          success: () => { console.log('分享给朋友成功'); }
        });
        wx.updateTimelineShareData({
          title: _this.subject.title,
          link: window.location.href,
          imgUrl: _this.wximg,
          success: () => { console.log('分享到朋友圈成功'); }
        });
      });
    }
  },
  // 20231113 更改
  mounted () {
    const _this = this;




    // 确保 wximg 和 subject.title 已赋值
    if (_this.wximg && _this.subject?.title) {
      _this.initWeChatShare();
    } else {
      this.$watch('wximg', (newVal) => {
        if (newVal && _this.subject?.title) {
          _this.initWeChatShare();
        }
      });
      this.$watch('subject.title', (newVal) => {
        if (newVal && _this.wximg) {
          _this.initWeChatShare();
        }
      });
    }
  },


  destroyed () {

  },
  beforeDestroy () {
    clearInterval(this.timer);
    this.timer = null;
  },

  // 监听器
  watch: {
    subjectMessagesLength () {
      this.pmmsgScroll();
    },

  },
  // 计算属性
  computed: {
    message () {
      // console.log('Status:', this.sign.status, 'Type:', typeof this.sign.status);
      if (this.sign.status == 1) {

        this.disabled = true;
        console.log('2');
        return '*恭喜您报名成功！';

      } else if (this.sign.status == 2) {
        this.disabled = true;

        // if (this.subject.bank_id == 5) {
        // 	return "*请完成线下保证金支付。吉林省崇晟科贸有限公司开户行:"+this.$global.banks[this.subject.id%5].account_bank+this.$global.banks[this.subject.id%5].account_number;
        // } else {
        // 	return '*报名审核中…请完成线下保证金支付';
        // }
        console.log('3');
        return "请完成线下保证金支付。<br>拍界（吉林省）拍卖有限公司<br>" + this.sign.bank + '<br>' + this.sign.i_acct_no;

      } else if (this.sign.status == 0) {
        // this.disabled = true;
        // return '*报名失败，可再次报名';
        if (this.sign.reason == null) {
          return "*报名失败，可再次报名";
        } else {
          return "驳回提示：" + this.sign.reason;
        }


      } else {

        return '';
      }

    },
    // 消息数量
    subjectMessagesLength () {
      return this.subjectMessages.length
    },
    // 开始时间
    startTime () {
      return new Date(this.subject.start_at.replace(/\-/g, '/')).getTime();
    },
    // 结束时间
    endTime () {
      return new Date(this.subject.end_at.replace(/\-/g, '/')).getTime();
    },
    // 开始剩余时间
    startBalanceTime () {
      return this.startTime - this.nowTime;
    },
    // 结束剩余时间
    endBalanceTime () {
      return this.endTime - this.nowTime;
    },
    // 保留价
    reserve_price () {
      return this.subject.reserve_price;
    },
    // 自由竞价时间
    sfreeTime () {
      let time = this.endTime - this.startTime;
      let dfreeTime = parseInt(time / 1000 / 3600 / 24);
      let hfreeTime = parseInt(time / 1000 / 3600 % 24);
      let mfreeTime = parseInt(time / 1000 / 60 % 60);

      let freeTime = '';

      if (mfreeTime > 0) {
        freeTime = mfreeTime + "分钟"
      }

      if (hfreeTime > 0) {
        freeTime = hfreeTime + "小时" + freeTime
      }

      if (dfreeTime > 0) {
        freeTime = dfreeTime + "天" + freeTime
      }
      return freeTime
    },
  },
  components: {
    BiaodiIntroduce,
    // BiaodiNotice,
    BiaodiSwiper,
    JpPress,
    // PicZoom
  }
}

</script>
<style scoped>
.my-bg {
  background: #eeeeee;
  padding: 0px 20px 10px 20px;
}
em.my-em {
  font-style: normal;
  color: #000000;
}
.my-endshow {
  color: #999999;
  font-size: 32px;
  margin: 50px 0 30px;
}

.pj-notice {
  background: #ffe1e1;
  color: #d6363b;
  border-top: 1px solid #d6363b;
  text-align: center;
  font-weight: bold;
  margin-top: -20px;
  margin-bottom: 20px;
  padding: 10px;
}
@media screen and (max-width: 540px) {
  .pj-notice {
    margin-top: 0px;
    margin-bottom: 20px;
  }
}
.input_margin {
  text-align: center;
}
.input_2024 {
  text-align: left;
}

/* ~~~~~~~~~~ */
.compact-upload {
  font-size: 13px;
}

.upload-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  padding: 8px 12px;
  background: #f9fafc;
  border-radius: 3px;
}

.upload-row:hover {
  background: #f0f4f8;
}

/* 上传标签样式 */
.upload-label {
  width: 120px;
  margin-right: 10px;
  color: #606266;
  font-weight: normal;
}

/* 状态图标样式 */
.status-icon {
  margin-left: 10px;
  font-size: 12px;
}

.status-icon i {
  margin-right: 3px;
}

/* 紧凑预览样式 */
.compact-preview {
  margin-left: 10px;
}

.compact-preview .el-image {
  width: 50px;
  height: 50px;
  border: 1px solid #e6e8eb;
  border-radius: 3px;
}

/* 联通注册提示框 */
.liantong-register-tip {
  display: flex;
  align-items: flex-start;
  padding: 15px 18px;
  margin-bottom: 15px;
  background: #f4f8ff;
  border: 1px solid #d8e8ff;
  border-left: 3px solid #409eff;
  border-radius: 6px;
}

/* 左侧图标 */
.register-icon {
  width: 36px;
  height: 36px;
  min-width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e3efff;
  border-radius: 8px;
  color: #409eff;
  font-size: 20px;
  margin-right: 12px;
}

/* 右侧内容 */
.register-content {
  flex: 1;
  min-width: 0;
}

.register-title {
  color: #303133;
  font-size: 14px;
  font-weight: bold;
  line-height: 22px;
}

.register-desc {
  color: #909399;
  font-size: 12px;
  line-height: 20px;
  margin-top: 4px;
}

/* 注册地址 */
.register-link {
  display: inline-block;
  margin-top: 7px;
  color: #409eff;
  font-size: 13px;
  text-decoration: none;
  overflow-wrap: anywhere;
}

.register-link:hover {
  color: #66b1ff;
  text-decoration: underline;
}

/* 手机端适配 */
@media screen and (max-width: 540px) {
  .liantong-register-tip {
    padding: 12px;
  }

  .register-icon {
    width: 30px;
    height: 30px;
    min-width: 30px;
    font-size: 17px;
    margin-right: 10px;
  }

  .register-title {
    font-size: 13px;
  }

  .register-desc {
    font-size: 12px;
  }
}
</style>